module.exports = __webpack_public_path__ + "static/media/52475639_2452965641445279_5970939182158184448_o.d0ef2142.jpg";